module.exports = __webpack_public_path__ + "img/6_1.d4ac0465.jpg";